import React, {useEffect, useState} from 'react';

import { MenuFoldOutlined } from '@ant-design/icons';
const Header = ({title}) => {
    useEffect(() => {
        document.title = title;
        scroll()
    }, []);
    const [isCollapse, setIsCollapse] = useState(true);
    const [collapseClassName, setCollapseClassName] = useState('collapse');
    const [headClassName, setHeadClassName] = useState('headClassName');
    const getCollapseIcon = function () {
        const navDom = document.querySelector('#nav')
        const viewDom = document.querySelector('#chartView')
        const headerDom = document.querySelector('.headClassName')
        if (isCollapse) {
            setIsCollapse(false)
            navDom.style.left = '-200px'
            viewDom.style.marginLeft = '0px'
            headerDom.style.left = '0px'
            setCollapseClassName('collapseRate')
        } else {
            navDom.style.left = '0px'
            viewDom.style.marginLeft = '200px'
            headerDom.style.left = '200px'
            setIsCollapse(true)
            setCollapseClassName('collapse')
        }
    }

    // 滚动内容，设置头部缩小
    const scroll = function () {
        document.querySelector('#chartView').addEventListener('scroll', (e) => {
            const scrollTop = e.target.scrollTop
            if (scrollTop > 80) {
                setHeadClassName('headClassName collapseHead')
            } else {
                setHeadClassName('headClassName')
            }
        })  
    }
    
    return (
        <header className={headClassName}>
            <MenuFoldOutlined onClick={getCollapseIcon} className={collapseClassName} />
            {title}
        </header>
    )
}

export default Header
